import React, { useState, useEffect, useRef } from 'react';
import TextTransition, { presets } from 'react-text-transition';

const slides = [
  {
    image:
      'https://img.freepik.com/free-photo/still-life-world-intellectual-property-day_23-2151325904.jpg?uid=R139167315&ga=GA1.1.821665019.1742142147&semt=ais_hybrid&w=740',
    title: 'Nduro Kimotho & Company Advocates',
    paragraph:
      'A full-service Nairobi-based law firm delivering practical, innovative, and results-driven legal solutions tailored to our clients’ business and personal needs.',
  },
  {
    image:
      'https://img.freepik.com/free-photo/african-american-manager-working-accountancy-report-analyzing-administrative-files-company-repository-businessman-checking-bureaucracy-record-searching-management-research_482257-71612.jpg?uid=R139167315&ga=GA1.1.821665019.1742142147&semt=ais_hybrid&w=740',
    title: 'Client-Centric Approach',
    paragraph:
      'We understand your objectives and risks, then provide clear legal advice that supports confident, informed decisions.',
  },
  {
    image:
      'https://img.freepik.com/free-photo/successful-businessmen-seal-deal-with-firm-handshake-generated-by-ai_188544-40065.jpg?uid=R139167315&ga=GA1.1.821665019.1742142147&semt=ais_hybrid&w=740',
    title: 'Practical Legal Solutions',
    paragraph:
      'Our multidisciplinary team delivers actionable legal solutions that protect your interests and move matters forward efficiently.',
  },
  {
    image:
      'https://img.freepik.com/free-photo/discussing-busines-report_1098-16536.jpg?uid=R139167315&ga=GA1.1.821665019.1742142147&semt=ais_hybrid&w=740',
    title: 'Trusted Legal Partners',
    paragraph:
      'We offer responsive, reliable legal support built on trust, professionalism, and long-term client relationships.',
  },
];

function AnimatedText({ text, duration = 400 }) {
  const [displayed, setDisplayed] = useState(text);
  const [fade, setFade] = useState(true);
  const prevText = useRef(text);

  useEffect(() => {
    if (prevText.current !== text) {
      setFade(false);
      const timeout = setTimeout(() => {
        setDisplayed(text);
        setFade(true);
        prevText.current = text;
      }, duration);
      return () => clearTimeout(timeout);
    }
  }, [text, duration]);

  return (
    <span
      style={{
        display: 'inline-block',
        width: '100%',
        transition: `opacity ${duration / 2}ms, transform ${duration / 2}ms`,
        opacity: fade ? 1 : 0,
        transform: fade ? 'translateY(0)' : 'translateY(20px)',
      }}
    >
      {displayed}
    </span>
  );
}

export const Header = () => {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearTimeout(timeoutRef.current);
  }, [current]);

  const goToSlide = (idx) => setCurrent(idx);

  return (
    <header id="header">
      <div className="intro-carousel-outer">
        <div
          className="intro-carousel-inner"
          style={{
            width: `${slides.length * 100}%`,
            transform: `translateX(-${current * (100 / slides.length)}%)`,
            transition: 'transform 1s cubic-bezier(0.77,0,0.175,1)',
          }}
        >
          {slides.map((slide, idx) => (
            <div
              className="intro-carousel-slide"
              key={idx}
              style={{
                background: `url('${slide.image}') center center/cover no-repeat`,
                width: `${100 / slides.length}%`,
                minHeight: '100vh',
              }}
            />
          ))}
        </div>
        <div className="intro-carousel-content">
          <div className="intro-text poppins-font">
            <h1 style={{ fontWeight: 700, marginBottom: 24 }}>
              <AnimatedText text={slides[current].title} />
              <span></span>
            </h1>
            <p style={{ fontWeight: 400, marginBottom: 40 }}>
              <AnimatedText text={slides[current].paragraph} />
            </p>
            <div style={{ marginBottom: 40 }}>
              {slides.map((_, idx) => (
                <span
                  key={idx}
                  onClick={() => goToSlide(idx)}
                  style={{
                    display: 'inline-block',
                    width: 14,
                    height: 14,
                    margin: '0 6px',
                    borderRadius: '50%',
                    background:
                      idx === current ? '#5ca9fb' : 'rgba(255,255,255,0.5)',
                    border:
                      idx === current
                        ? '2px solid #fff'
                        : '2px solid transparent',
                    cursor: 'pointer',
                    transition: 'background 0.4s, border 0.4s',
                  }}
                />
              ))}
            </div>
            <a
              href="#features"
              className="btn btn-custom btn-lg page-scroll"
              style={{ marginTop: 10 }}
            >
              Get in Touch
            </a>
          </div>
        </div>
        <div className="intro-carousel-overlay" />
      </div>
    </header>
  );
};
